import { render, staticRenderFns } from "./edit-cardSku.vue?vue&type=template&id=17290fc9"
import script from "./edit-cardSku.vue?vue&type=script&lang=ts"
export * from "./edit-cardSku.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports